module.exports = __webpack_public_path__ + "public/img/duihuakuang.e301d747.png";